import React, { FC } from 'react'
import { Image } from 'react-bootstrap'
import { observer, inject } from 'mobx-react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { FaUser } from 'react-icons/fa'
import CompanyImg from '../../../../assets/img/gray_logo_icon.svg'
import HotCompanyImg from '../../../../assets/img/logo-filled.png'
import { Prospects as ProspectsStore } from '../../../../stores/prospects'

interface Props extends RouteComponentProps {
  prospects?: ProspectsStore
  name?: string
  title?: string
  addedBy?: string
  sender?: string
  email?: string
  isHot?: boolean
}
const Header: FC<Props> = ({ name, title, addedBy, isHot }) => {
  return (
    <div className="info-header">
      {addedBy === 'User' ? (
        <div className={`avatar-icon ${isHot ? 'hot' : ''}`}>
          <FaUser />
        </div>
      ) : (
        <>
          {!isHot && <Image src={CompanyImg} alt="Placeholder" className="avatar" roundedCircle />}
          {isHot && (
            <Image src={HotCompanyImg} alt="Placeholder" className="avatar" roundedCircle />
          )}
        </>
      )}
      <h3>{name}</h3>
      <h4>{title}</h4>
    </div>
  )
}

export default inject('prospects')(withRouter(observer(Header)))
